import React from 'react';

//Calling React's Context API in order to call the Google Api only once
//at the top-level of the component hierarchy in App component.
const GoogleAPIContext = React.createContext(null);

export default GoogleAPIContext;
